<template>
  <v-container
    fluid
    fill-height
  >
    <confirmation-dialog ref="confirm" />
    <v-row class="align-center justify-right">
      <v-col
        cols="6"
        md="3"
      >
        <search-field v-model="search" />
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-col>
        <h2>Invitations awaiting response</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :loading="receivedClientInvitationsLoading"
          :items="receivedClientInvitations"
          :headers="invitationHeaders"
          :search="search"
          no-data-text="No invitations awaiting response"
        >
          <template #[`item.actions`]="{ item }">
            <v-btn
              color="primary"
              small
              :disabled="isSaving(item)"
              @click="acceptInvitation(item)"
            >
              Accept
            </v-btn>
            <v-btn
              color="secondary"
              small
              class="ml-1 mr-1"
              :disabled="isSaving(item)"
              @click="declineInvitation(item)"
            >
              Decline
            </v-btn>
            <v-progress-circular
              v-show="isSaving(item)"
              indeterminate
              color="primary"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SearchField from '@/components/SearchField'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import { asRecordId } from '../dataAccess/queries'

export default {
  name: 'ManageInvitations',
  components: {
    ConfirmationDialog,
    SearchField
  },
  data: function () {
    return {
      saving: {},
      search: null,
      invitationHeaders: [
        {
          text: 'From User',
          value: 'fromUserName',
          filterable: true,
          sortable: true
        },
        {
          text: 'From Account',
          value: 'fromAccountName',
          filterable: true,
          sortable: true
        },
        {
          value: 'actions',
          filterable: false,
          sortable: false,
          align: 'start',
          width: '40%'
        }
      ]
    }
  },
  beforeCreate() {
    this.mapStates([
      'receivedClientInvitations',
      'receivedClientInvitationsLoading'
    ])
    this.$store.dispatch('get_receivedClientInvitations').then(() => {
      this.saving = this.receivedClientInvitations.reduce((acc, invite) => {
        acc[asRecordId(invite)] = false
        return acc
      }, {})
    })
  },
  methods: {
    async acceptInvitation(invite) {
      const name = this.invitationName(invite)
      if (
        await this.$refs.confirm.open(
          'Accept invitation?',
          `If you accept this invitation, ${name} will be able to initiate contracts on your behalf.`,
          { type: 'info' }
        )
      ) {
        this.setSaving(invite, true)
        this.$handlingError(
          `Error accepting invitation from "${name}"`,
          async () => {
            await this.$api.acceptClientInvitation(invite)
            this.$showSuccessbar(`Accepted invitation from "${name}"`)
          },
          { final: () => this.setSaving(invite, false) }
        )
      }
    },
    async declineInvitation(invite) {
      const name = this.invitationName(invite)
      if (
        await this.$refs.confirm.open(
          'Decline invitation?',
          `The invitation will be deleted and ${name} will receive a notification that you have declined.`,
          { type: 'info' }
        )
      ) {
        this.setSaving(invite, true)
        this.$handlingError(
          `Error declining invitation from "${name}"`,
          async () => {
            await this.$api.declineClientInvitation(invite)
            this.$showSuccessbar(`Declined invitation from "${name}"`)
          },
          { final: () => this.setSaving(invite, false) }
        )
      }
    },
    isSaving(invite) {
      return this.saving[asRecordId(invite)]
    },
    setSaving(invite, value) {
      this.saving[asRecordId(invite)] = value
    },
    invitationName(invite) {
      return invite.fromAccountName
    }
  }
}
</script>
